import React, { useState, useEffect } from "react";
import _ from "lodash";
import PharmacySelect from "./PharmacySelect";
import NotPermitted from "../../shared/designations/NotPermitted";
import { useTranslation, Trans } from "react-i18next";

const LdnDesignationForm = ({
  manufacturerFormDetails,
  setManufacturerFormDetails,
  manufacturer,
  manufacturerVanityName,
  entities,
  network,
  isBlocked,
}) => {
  const { t, i18n } = useTranslation("designations");
  const [ldnDesignation, setLdnDesignation] = useState(false);
  const [confirmedPolicy, setConfirmedPolicy] = useState(false);
  const [hasSelectedPharmacy, setHasSelectedPharmacy] = useState(false);
  const [selectedPharmacy, setSelectedPharmacy] = useState(false);
  const networkVanityName = network.charAt(0).toUpperCase() + network.slice(1);
  const registeredTrademarkNetwork = `${network.toUpperCase()}®`;

  const mfrPolicy = t(`${manufacturer}.${network}.attestation`, {
    manufacturerVanityName,
    network,
    registeredTrademarkNetwork,
  });
  const mfrDesQuestion = t(`${manufacturer}.${network}.question`, {
    manufacturerVanityName,
    network,
    registeredTrademarkNetwork,
  });
  const mfrDesSubtitle = t(`${manufacturer}.${network}.subtitle`, {
    networkVanityName,
  });

  useEffect(() => {
    const formDetails = _.cloneDeep(manufacturerFormDetails);
    formDetails[manufacturer].ldnDesignationForm = {
      open: ldnDesignation,
      completed: hasSelectedPharmacy,
    };
    setManufacturerFormDetails(formDetails);
  }, [ldnDesignation, hasSelectedPharmacy]);

  const policies = () => {
    if (isBlocked) {
      return <NotPermitted confirmedPolicy={confirmedPolicy} />;
    }

    return (
      <div
        className={
          confirmedPolicy
            ? "designation_form__section__group__step__toggle_container designation_form__section__group__step__toggle_container--closed"
            : "designation_form__section__group__step__toggle_container"
        }
      >
        <div className="stat-cards__confirmation stat-cards__confirmation--disabled">
          <span style={{ whiteSpace: "pre-line" }}>{mfrPolicy}</span>
          {renderConfirmation()}
        </div>
      </div>
    );
  };

  const renderLdnDesignationForm = () => {
    return (
      <div className="designation_form__section__group">
        <div className="designation_form__section__group__row">
          <div className="designation_form__section__group__question">
            <div className="designation_form__section__group__question__subtitle">
              {mfrDesSubtitle}
            </div>
            {mfrDesQuestion}
          </div>
          <div className="designation_form__section__group__value">
            <div className="btn__option__group">
              <div
                className={ldnDesignation ? "btn btn--small btn--selected" : "btn btn--small"}
                onClick={() => setLdnDesignation(true)}
              >
                yes
              </div>
              <div
                className={ldnDesignation ? "btn btn--small" : "btn btn--small btn--selected"}
                onClick={() => setLdnDesignation(false)}
              >
                no
              </div>
            </div>
          </div>
        </div>
        {renderPolicy()}
        {renderStep()}
      </div>
    );
  };

  const renderConfirmation = () => {
    return (
      <div className="stat-cards__confirmation__footer">
        <span>
          <div className="indicator indicator--red indicator--pulse" style={{ marginTop: 3 }}></div>
          Please confirm policy before assigning designation.
        </span>
        <span>
          <div className="btn btn--ib btn--tiny" onClick={() => setConfirmedPolicy(true)}>
            Confirm
          </div>
        </span>
      </div>
    );
  };

  const renderStepIndicator = (step) => {
    if (step) {
      return (
        <div className="designation_form__section__group__step__indicator designation_form__section__group__step__indicator--complete">
          <i className="solid solid-budicon-check-ui" />
        </div>
      );
    } else {
      return <div className="designation_form__section__group__step__indicator"></div>;
    }
  };

  const renderPolicy = () => {
    if (ldnDesignation) {
      return (
        <div className="designation_form__section__group__step">
          {renderStepIndicator(confirmedPolicy)}
          <div className="designation_form__section__group__step__title">Policy Confirmation</div>
          <div className="designation_form__section__group__step__subtitle">
            Please confirm manufacturer's policy to continue.
          </div>
          {policies()}
        </div>
      );
    }
  };

  const renderNoticeHasExistingDesignation = (entity) => {
    var designation = entity.designations_count[manufacturer];

    if (designation && designation[network] > 0) {
      return (
        <div
          className="stat-cards__notice stat-cards__notice--blue stat-cards__notice--mb"
          style={{ lineHeight: 1.5 }}
        >
          The selected covered entity already made a contract pharmacy designation, please login to
          or register an account with 340B ESP to view the details of this designation. If you have
          questions, please reach out to support@340besp.com.
        </div>
      );
    }
  };

  const filterPharmacies = (entity) => {
    return _.filter(entity.pharmacies.details, { [manufacturer]: [network] });
  };

  const renderPharmacySelect = () => {
    return _.map(entities, (entity, index) => (
      <div key={index}>
        {renderNoticeHasExistingDesignation(entity)}
        <PharmacySelect
          kind={network}
          entity={entity}
          pharmacies={filterPharmacies(entity)}
          manufacturer={manufacturer}
          selectedPharmacy={selectedPharmacy}
          setSelectedPharmacy={setSelectedPharmacy}
          setHasSelectedPharmacy={setHasSelectedPharmacy}
        />
      </div>
    ));
  };

  const renderStep = () => {
    if (ldnDesignation && confirmedPolicy) {
      return (
        <div className="designation_form__section__group__step">
          {renderStepIndicator(hasSelectedPharmacy)}
          <div className="designation_form__section__group__step__title">
            Select Contract Pharmacy
          </div>
          <div className="designation_form__section__group__step__subtitle">
            Please select a contract pharmacy to designate.
          </div>
          {renderPharmacySelect()}
        </div>
      );
    }
  };

  return renderLdnDesignationForm();
};

export default LdnDesignationForm;
